module.exports = __webpack_public_path__ + "img/spin_btn.951dcf6b.png";